import React from 'react'
import Wrapper from './Wrapper'
import Link from 'gatsby-link'
import ReadMore from './ReadMore'
import { rhythm } from '../../utils/typography'

// Import typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'

const PostSummary = props => (
    <Wrapper className="text-left">
        <h3 style={{ fontSize: rhythm(0.9), marginBottom: rhythm(0.2) }}>
            <Link style={{ boxShadow: 'none', color: '#007acc' }} to={props.slug}>
                {props.title}
            </Link>
        </h3>
        <p style={{
            fontSize: rhythm(0.55),
            fontStyle: "italic",
            color: "#888",
            marginBottom: rhythm(0.5)
        }}>{props.date}</p>
        <p dangerouslySetInnerHTML={{ __html: props.excerpt }} />
        <p className="text-right">
            <ReadMore to={props.slug}>Read more</ReadMore>
        </p>
        <hr style={{ marginBottom: rhythm(1) }} />
    </Wrapper >
);

export default PostSummary;



// WEBPACK FOOTER //
// ./src/components/PostSummary/index.js